const SEARCH_KINDS = [
  'reader_search_query',
  'reader_search_results',
  'reader_search_total',
  'reader_has_searched',
]

export const emptySearchHistory = () => ({
  searchQuery: '',
  searchResults: [],
  totalResults: 0,
  hasSearched: false,
})

export function normalizeSearchIdentity(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  const normalized = String(value).trim()
  if (/^(none|null|undefined)$/i.test(normalized)) return ''
  try {
    encodeURIComponent(normalized)
    return normalized
  } catch (error) {
    return ''
  }
}

const storageKey = (scope, kind) => {
  const userId = normalizeSearchIdentity(scope.userId)
  const coursenum = normalizeSearchIdentity(scope.coursenum)
  return userId && coursenum
    ? `ai:v2:${encodeURIComponent(userId)}:${encodeURIComponent(
        coursenum
      )}:${kind}`
    : null
}

// These records have no known user owner. Never migrate them, or clear unrelated
// reader/preferences data while removing the four legacy search families.
export function removeLegacySearchHistory() {
  try {
    Object.keys(localStorage).forEach(key => {
      if (SEARCH_KINDS.some(kind => key.startsWith(`${kind}_`))) {
        localStorage.removeItem(key)
      }
    })
  } catch (error) {
    // Search remains usable when browser storage is unavailable.
  }
}

export function readSearchHistory(scope) {
  removeLegacySearchHistory()
  const empty = emptySearchHistory()
  if (!storageKey(scope, SEARCH_KINDS[0])) return empty
  try {
    const [queryKey, resultsKey, totalKey, searchedKey] = SEARCH_KINDS.map(
      kind => storageKey(scope, kind)
    )
    const results = JSON.parse(localStorage.getItem(resultsKey) || '[]')
    const total = Number(localStorage.getItem(totalKey) || 0)
    return {
      searchQuery: localStorage.getItem(queryKey) || '',
      searchResults: Array.isArray(results)
        ? results.filter(
            result =>
              result &&
              typeof result === 'object' &&
              typeof result.title === 'string' &&
              typeof result.subtitle === 'string' &&
              typeof result.text === 'string' &&
              (!result.url || typeof result.url === 'string')
          )
        : [],
      totalResults: Number.isFinite(total) && total >= 0 ? total : 0,
      hasSearched: localStorage.getItem(searchedKey) === 'true',
    }
  } catch (error) {
    return empty
  }
}

export function writeSearchHistory(scope, history) {
  if (!storageKey(scope, SEARCH_KINDS[0])) return
  const values = [
    history.searchQuery,
    JSON.stringify(history.searchResults),
    String(history.totalResults),
    String(history.hasSearched),
  ]
  try {
    SEARCH_KINDS.forEach((kind, index) => {
      localStorage.setItem(storageKey(scope, kind), values[index])
    })
  } catch (error) {
    // Persistence is optional; do not interrupt an in-memory search.
  }
}
